import React from 'react';

import { AriseBridgeHost } from '@/arise/bridge/AriseBridgeHost';
import { DiscordAuthFlowMethods } from '@/components/DiscordAuthFlow';
import { IS_DISCORD_ACTIVITY } from '@/globals';
import { sendEvent } from '@/utils/analytics';
import { getCountryCode } from '@/utils/localisation';

export function useMimasEvents(discordRef: React.RefObject<DiscordAuthFlowMethods>, bridgeRef: AriseBridgeHost) {
    function onCheckpointReached(data) {
        sendEvent('mi_checkpoint_reached', data.detail);
    }

    async function pushCountryCode() {
        const code = await getCountryCode();
        bridgeRef.sendEvent('push-country-code', code);
    }

    return {
        onCheckpointReached,
        pushCountryCode,
    };
}
